import React from 'react';

export default function SelectionLabel({
  isDragging,
}: {
  isDragging: boolean;
}) {
  return (
    <div
      className={`absolute w-full left-1/2 bottom-0 rounded-b-xl px-4 py-2 transition-colors duration-150  border-t-2 ${
        isDragging
          ? 'bg-yellow-300 border-yellow-300'
          : 'bg-yellow-400 border-yellow-400'
      }`}
      style={{
        transform: 'translateX(-50%) translateY(100%)',
      }}
    >
      <div className="text-gray-900 text-xs font-semibold whitespace-nowrap text-center">
        :: Drag to select up to 5 seconds ::
      </div>
    </div>
  );
}
